import { createContext } from 'react';

import {
  ConnectionsType,
  DonorScheduleType,
  DonorSchedulingType,
  PageTitleType,
  PartnershipFormType,
  PrimaryNavType,
  ThemeType,
  UserType,
} from '@/services';

export type PrimaryContext = UserType &
  PageTitleType &
  ThemeType &
  PrimaryNavType &
  ConnectionsType &
  DonorScheduleType &
  DonorSchedulingType &
  PartnershipFormType;

export const initialState: UserType &
  PageTitleType &
  ThemeType &
  PrimaryNavType &
  ConnectionsType &
  DonorScheduleType &
  DonorSchedulingType &
  PartnershipFormType = {
  me: null,
  setMe: () => {},
  pageTitle: 'Nucleus',
  setPageTitle: () => {},
  themeMode: 'light',
  setThemeMode: () => {},
  isLoggedIn: false,
  setIsLoggedIn: () => {},
  primaryNavPinned: true,
  setPrimaryNavPinned: () => {},
  connections: undefined,
  setConnections: () => {},
  currentConnection: null,
  setCurrentConnection: () => {},
  donorSchedules: undefined,
  setDonorSchedules: () => {},
  selectedDonorSchedules: undefined,
  setSelectedDonorSchedules: () => {},
  workingDonorSchedule: undefined,
  setWorkingDonorSchedule: () => {},
  partnership: undefined,
  setPartnership: () => {},
  csr: undefined,
  setCsr: () => {},
  quickFilterText: undefined,
  setQuickFilterText: () => {},
  selectedDonor: undefined,
  setSelectedDonor: () => {},
};

export const PrimaryContext = createContext(initialState);
